import React from 'react'
import { SiteHeader } from '../components/site-header'
import { SurveyOptions } from '../components/survey/survey-options'
import { PageHero } from '../components/ui/page-hero'

export default function SurveyPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          title="SLK Profile™ Survey"
          description="Evaluate leadership tendencies and optimise strategic alignment across your organisation."
          backgroundImage="/images/backgrounds/flickr-21903280519.jpg"
          backgroundAlt="Survey background"
        >
          <SurveyOptions />
        </PageHero>
      </main>
    </div>
  )
}